import { createParser } from 'nuqs';
import { StationTypeFilterType } from '../components/options';

const STATION_TYPE_FILTER_VALUES = new Set<string>([
  StationTypeFilterType.RADIO,
  StationTypeFilterType.TV,
  StationTypeFilterType.YOUTUBE,
]);

function isStationTypeFilterValue(value: string): value is StationTypeFilterType {
  return STATION_TYPE_FILTER_VALUES.has(value);
}

/**
 * nuqs parser for the status screen `type` query param.
 * Supports a comma-separated list (e.g. `radio,tv`) or a single value (e.g. `youtube`).
 * Null/absent means no station-type filter (show all types).
 */
export const parseAsStationTypeFilter = createParser<StationTypeFilterType[] | null>({
  parse(value) {
    if (value == null || typeof value !== 'string' || !value.trim()) {
      return null;
    }

    const types = value
      .split(',')
      .map((segment) => segment.trim())
      .filter(isStationTypeFilterValue);

    return types.length > 0 ? types : null;
  },
  serialize(value) {
    if (value == null || value.length === 0) {
      return '';
    }

    return value.join(',');
  },
  eq(a, b) {
    if (a == null && b == null) {
      return true;
    }

    if (a == null || b == null) {
      return false;
    }

    if (a.length !== b.length) {
      return false;
    }

    return a.every((type, index) => type === b[index]);
  },
});
